import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { ThemeId } from '../theme/themes'
import api from '../services/api'

interface UIState {
  /** Oculta valores monetários na tela (privacidade em locais públicos). */
  hiddenValues: boolean
  toggle: () => void
  sidebarCollapsed: boolean
  toggleSidebar: () => void
  theme: ThemeId
  setTheme: (t: ThemeId) => void
}

function getInitialTheme(): ThemeId {
  try {
    const stored = localStorage.getItem('ct-theme')
    if (stored === 'light' || stored === 'dark') return stored
    if (window.matchMedia('(prefers-color-scheme: light)').matches) return 'light'
  } catch {
    // ignora erros de SSR/iframe
  }
  return 'dark'
}

/** Store de estado de interface (Zustand) — persiste tema e sidebarCollapsed no localStorage. */
export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      hiddenValues: false,
      toggle: () => set(s => ({ hiddenValues: !s.hiddenValues })),

      sidebarCollapsed: false,
      toggleSidebar: () => set(s => ({ sidebarCollapsed: !s.sidebarCollapsed })),

      theme: getInitialTheme(),
      setTheme: (theme) => {
        set({ theme })
        localStorage.setItem('ct-theme', theme)
        document.documentElement.dataset.theme = theme
        api.patch('/auth/me/preferences', { theme }).catch(() => {})
      },
    }),
    {
      name: 'ct-ui',
      partialize: (s) => ({ theme: s.theme, sidebarCollapsed: s.sidebarCollapsed }),
    }
  )
)
